import React, { useEffect, useState } from "react";
// import GroupwiseFinanceReport from "../../components/features/finance/GroupwiseFinanceReport";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPageTitle } from "../../store/slices/pageSlice";
import FinanceOverview from "./financeOverview/FinanceOverview";
import { fetchEmployees } from "../../store/slices/employeeSlice";
import { hasViewOrFullAccess, getFeatureAccessLevel } from "../../utils/featureAccessUtils";

const Finance = ({ wrapperClasses }) => {
  const dispatch = useDispatch();
  const { session } = useSelector((state) => state.session);
  const { employees } = useSelector((state) => state.employees);
  const [currentEmployee, setcurrentEmployee] = useState();
  const email = localStorage.getItem("email");
  const userLevel = session?.auth || localStorage.getItem("auth") || "";
  console.log("currentEmployee", window.innerWidth)


  useEffect(() => {
    const employee = employees.find((emp) => emp.EmpEmail === email);
    setcurrentEmployee(employee);
  }, [email, employees]);
  // const userLevel = localStorage.getItem("userRole") || session.auth;

  useEffect(() => {
    const title =
      userLevel === "L5" ? "Accounts department" : "Finance Dashboard";
    dispatch(setCurrentPageTitle(title));
    dispatch(fetchEmployees());
  }, [dispatch, userLevel]);

  // L2 with "No Access" to PROFIT AND LOSS: hide entire page (sidebar and table).
  const plAccessLevel = getFeatureAccessLevel(currentEmployee, "PROFIT AND LOSS");
  const isL2NoAccessToPL = userLevel === "L2" && String(plAccessLevel || "").trim().toUpperCase() === "NO ACCESS";

  const hasAccess =
    !isL2NoAccessToPL &&
    (["L0", "L1"].includes(userLevel) ||
    hasViewOrFullAccess(currentEmployee, "PROFIT AND LOSS"));

  return (
    hasAccess && (
      <div className={wrapperClasses}>
        <div>
          <FinanceOverview />
        </div>
      </div>
    )
  );
};

export default Finance;
